import React from 'react';
import './Footer.css';
import { getImagePath } from '../../utils/pathUtils';
import { socialData } from '../../utils/socialData';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-widget about-widget">
              <div className="footer-logo">
                <img 
                  src={getImagePath('skillyatra_logo.png')} 
                  alt="SkillYatra Logo" 
                  className="footer-logo-img"
                />
                {/* <h3 className="footer-logo-text">SkillYatra</h3> */}
              </div>
              <p>
                Empowering careers through quality education and industry-relevant skills. 
                Join us on your learning journey to success.
              </p>
              <div className="social-links">
                {socialData.socialLinks.map((social, index) => {
                  const IconComponent = require('react-icons/fa')[social.icon];
                  return (
                    <a 
                      key={index}
                      href={social.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="social-link"
                      style={{ '--social-color': social.color }}
                      aria-label={social.name}
                    >
                      <IconComponent className="social-icon" />
                    </a>
                  );
                })}
              </div>
            </div>
            
            <div className="footer-widget">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#courses">Courses</a></li>
                <li><a href="#reviews">Reviews</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            
            <div className="footer-widget">
              <h4>Our Courses</h4>
              <ul className="footer-links">
                <li><a href="#courses">Flutter + Firebase</a></li>
                <li><a href="#courses">MERN Stack (Full Stack)</a></li>
                <li><a href="#courses">3ds Max + V-ray</a></li>
              </ul>
            </div>
            
            <div className="footer-widget contact-widget">
              <h4>Contact Info</h4>
              <ul className="contact-info">
                {Object.entries(socialData.contactInfo).map(([key, info]) => {
                  const IconComponent = {
                    phone: FaPhoneAlt,
                    email: FaEnvelope,
                    location: FaMapMarkerAlt
                  }[key];
                  
                  return (
                    <li key={key}>
                      <IconComponent className="contact-icon" />
                      {info.url ? (
                        <a href={info.url} className="contact-link">{info.value}</a>
                      ) : (
                        <span>{info.value}</span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <p>&copy; {currentYear} SkillYatra. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
